<template>
  <div class="program-list-item row">

    <div class="col program-name">
      <span
        v-text="$ml.get('finished')"
        v-if="program.finished"
        class="finish-badge"
      />
      <router-link :to="`/dashboard/programs/${program.id}`">
        {{ program.name }}
      </router-link>
    </div>

    <div class="col farm-field-name">
      <template v-if="$store.getters['farms/getFieldById'](program.fieldId) && $store.getters['farms/getFarmById'](program.farmId)">
        <span>
          {{ $store.getters['farms/getFarmById'](program.farmId).name }}
        </span>
        /
        <span>
          {{ $store.getters['farms/getFieldById'](program.fieldId).name }}
        </span>
      </template>
      <template v-else>-</template>
    </div>

    <div class="col crop">
      <template v-if="program.cropName">{{ $ml.get(program.cropName) }}</template>
      <template v-else>-</template>
    </div>

    <div class="col fert-method">
      {{ $ml.get(program.type) }}
    </div>

    <div class="col start-date">
      <template v-if="program.plantingDate.length < 15">{{ program.plantingDate }}</template>
      <template v-else>-</template>
    </div>

    <div class="col actions" v-if="$store.getters['user/plan'] != 'impact'">
      <button
        @click="deleteProgram(program)"
        class="h-empty-btn delete h-btn"
      >
        <svg width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.99793 4L7.79119 1.20674C7.92376 1.0744 7.99833 0.894828 7.99849 0.707514C7.99866 0.520201 7.92441 0.340493 7.79207 0.207926C7.65974 0.0753579 7.48016 0.000789271 7.29285 0.000623849C7.10554 0.000458426 6.92583 0.0747098 6.79326 0.207043L4 3.00031L1.20674 0.207043C1.07417 0.0744758 0.894369 0 0.70689 0C0.519412 0 0.339611 0.0744758 0.207043 0.207043C0.0744758 0.339611 0 0.519412 0 0.70689C0 0.894369 0.0744758 1.07417 0.207043 1.20674L3.00031 4L0.207043 6.79326C0.0744758 6.92583 0 7.10563 0 7.29311C0 7.48059 0.0744758 7.66039 0.207043 7.79296C0.339611 7.92552 0.519412 8 0.70689 8C0.894369 8 1.07417 7.92552 1.20674 7.79296L4 4.99969L6.79326 7.79296C6.92583 7.92552 7.10563 8 7.29311 8C7.48059 8 7.66039 7.92552 7.79296 7.79296C7.92552 7.66039 8 7.48059 8 7.29311C8 7.10563 7.92552 6.92583 7.79296 6.79326L4.99793 4Z"/>
        </svg>
      </button>
    </div>

  </div>
</template>

<script>
import { ProgramAPI } from '@/api'

export default {
  props: {
    program: {

    }
  },


  methods: {
    deleteProgram(item) {
     this.$store.commit('modals/prompt/open', {
       onAccept: () => {
         return ProgramAPI.deleteProgram(item.id).then(res => {
           this.$emit('update')
         });
       },
       onCancel: () => {

       },
       // TODO: добавить перевод
       text: this.$ml.get('Are you sure?'),
     });
   },
  }
}
</script>

<style lang="scss" scoped>

.program-list-item {

  &:last-child {
    border-bottom: 0;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E4E5E6;

  .col {
    flex-grow: 2;
    flex-basis: 16%;
    padding: 8px;
    line-height: 1.5;

    &.program-name,
    &.farm-field-name {
      flex-basis: 26%;
    }

    &.fert-method {
      text-transform: capitalize;
    }

    .finish-badge {
      font-weight: bold;
      font-size: 12px;
      margin-right: 10px;
      text-transform: uppercase;
      background: $mainGreen;
      color: #fff;
      padding: 3px 5px;
      border-radius: 3px;
      line-height: 1;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      user-select: none;
    }

    .delete {
      width: 30px;
      height: 30px;
      transition: background 0.3s ease;
      border-radius: 100%;

      svg {
        fill: #E8282F;
      }

      &:hover {
        background: rgba(#E8282F, 0.15);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    > * {
      margin-bottom: 4px;
      &.actions {
        display: none;
      }
    }
  }
}

</style>
